// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"117":"11e6fc6c","341":"15a6f735","422":"8b1b7e25"}[chunkId] + ".chunk.js";
};